import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { getValidationSummaryGroups } from './regressionCoverageEvidencePresentation';

const MetricCard = ({ label, value }) => (
  <Paper variant="outlined" sx={{ p: 1.5, height: '100%' }}>
    <Typography variant="caption" color="text.secondary" display="block">
      {label}
    </Typography>
    <Typography variant="h6">{value}</Typography>
  </Paper>
);

const SummaryGroup = ({ title, children }) => (
  <Box sx={{ mb: 2 }}>
    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
      {title}
    </Typography>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', sm: 'repeat(3, minmax(0, 1fr))', md: 'repeat(5, minmax(0, 1fr))' },
        gap: 1.5,
      }}
    >
      {children}
    </Box>
  </Box>
);

const RegressionValidationCoverageSummary = ({ structuredReport, rawReport }) => {
  const groups = getValidationSummaryGroups(structuredReport, rawReport);
  const { productCoverage, testEvidence } = groups;

  return (
    <Box>
      <SummaryGroup title="Product coverage">
        <MetricCard
          label="Coverage %"
          value={productCoverage.coveragePercent != null ? `${productCoverage.coveragePercent}%` : '-'}
        />
        <MetricCard
          label="Product coverage units"
          value={productCoverage.coverageUnitsTotal ?? '-'}
        />
        <MetricCard label="Covered" value={productCoverage.covered} />
        <MetricCard label="Partial match" value={productCoverage.partial} />
        <MetricCard label="Missing" value={productCoverage.missing} />
      </SummaryGroup>

      <SummaryGroup title="Test evidence">
        <MetricCard label="Approved tests considered" value={testEvidence.approvedTestsConsidered} />
        {testEvidence.generatedSuggestionsPending != null && (
          <MetricCard
            label="Generated suggestions pending approval"
            value={testEvidence.generatedSuggestionsPending}
          />
        )}
        {testEvidence.matcherMode && (
          <MetricCard label="Matching mode" value={testEvidence.matcherMode} />
        )}
        {testEvidence.qualifierConfigStatus && (
          <MetricCard label="Qualifier config" value={testEvidence.qualifierConfigStatus} />
        )}
      </SummaryGroup>
    </Box>
  );
};

export default RegressionValidationCoverageSummary;
